import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core/styles';
import { OrgUserStatus } from 'src/types';
import { getColor } from './utils/utils';

interface Props {
  status: OrgUserStatus;
}

const useStylesOrgUserStatus = makeStyles<Theme, Props>((theme: Theme) => ({
  icon: ({ status }) => ({
    width: 20,
    height: 20,
    color: getColor(theme, status),
  }),
  title: ({ status }) => ({
    marginLeft: 10,
    color: getColor(theme, status),
    textTransform: 'capitalize',
  }),
}));

export { useStylesOrgUserStatus };
